module.exports = {
	"tokenSecret": "thisisasecretstring",
	"namespace": "/_/console",
	"proxy": true,
	"iamHostProtocol": "http",
	"iamHost": "localhost",
	"iamPort": 8600,
	"stsPort": 8800,
	"utapiPort": 8100,
	"maxUtapiDataPoints": 50,
	"s3Port": 8000,
	"apiHost": "localhost",
	"apiHosts": [
		"localhost"
	],
	"apiPort": 8700,
	"uiHost": "localhost",
	"uiPort": 80,
	"log": {
		"logLevel": "info",
		"dumpLevel": "error"
	},
	"scubaConfig": {
		"scubaHost": "localhost",
		"scubaPort": 18100,
		"queryBatchSize": 10000,
		"scubaServiceUser": "service-scuba-user"
	},
	"cors": {
		"origin": true,
		"credentials": true,
		"methods": [
			"GET",
			"POST",
			"PUT",
			"DELETE",
			"OPTIONS",
			"HEAD"
		],
		"allowedHeaders": [
			"Content-Type",
			"Authorization",
			"x-access-token"
		],
		"maxAge": 86400
	},
	"metricsBackend": "scuba"
};


/*****************
 ** WEBPACK FOOTER
 ** ../config.json
 ** module id = 13
 ** module chunks = 0
 **/